// extracted by mini-css-extract-plugin
export default {"modelPerformanceHeader":"ModelPerformance_modelPerformanceHeader__m+Dis","title":"ModelPerformance_title__RXMxi","filtrate":"ModelPerformance_filtrate__H8bXD"};